import { haloWorldRequest } from '../../utils/haloWorldRequest';

export async function login(data) {
  return haloWorldRequest({
    method: 'post',
    url: '/api/login',
    data: {
      ...data
    }
  });
}

export async function getAccountInfo() {
  return haloWorldRequest({
    method: 'get',
    url: '/api/invite/GetAccountInfo',
    headers: {
      Authorization: sessionStorage.getItem('haloWorldToken')
    },
  });
}

export async function getInviteRankingData() {
  return haloWorldRequest({
    method: 'get',
    url: '/api/public/GetInviteRankingData',
  });
}

export async function getConfig() {
  return haloWorldRequest({
    method: 'get',
    url: '/api/public/InviteConfig',
  });
}

export async function getAccountMintInfo(params) {
  return haloWorldRequest({
    method: 'get',
    url: '/api/invite/GetAccountMintInfo',
    headers: {
      Authorization: sessionStorage.getItem('haloWorldToken')
    },
    params: {
      ...params
    }
  });
}

export async function getInviteeMintInfo(params) {
  return haloWorldRequest({
    method: 'get',
    url: '/api/invite/GetAccountInviteMintInfo',
    headers: {
      Authorization: sessionStorage.getItem('haloWorldToken')
    },
    params: {
      ...params
    }
  });
}

export async function getAccountInviteInfo(params) {
  return haloWorldRequest({
    method: 'get',
    url: '/api/invite/GetAccountInviteInfo',
    headers: {
      Authorization: sessionStorage.getItem('haloWorldToken')
    },
    params: {
      ...params
    }
  });
}

export async function getTransferHistory(params) {
  return haloWorldRequest({
    method: 'get',
    url: '/api/invite/GetAccountTransferHistory',
    headers: {
      Authorization: sessionStorage.getItem('haloWorldToken')
    },
    params: {
      ...params
    }
  });
}

export async function getExchangeHistory(params) {
  return haloWorldRequest({
    method: 'get',
    url: '/api/invite/GetAccountCostHistory',
    headers: {
      Authorization: sessionStorage.getItem('haloWorldToken')
    },
    params: {
      ...params
    }
  });
}

export async function getMintSign() {
  return haloWorldRequest({
    method: 'post',
    url: '/api/invite/LaunchClaim',
    headers: {
      Authorization: sessionStorage.getItem('haloWorldToken')
    },
  });
}

export async function exchangeBox() {
  return haloWorldRequest({
    method: 'post',
    url: '/api/invite/BuyBox',
    headers: {
      Authorization: sessionStorage.getItem('haloWorldToken')
    },
  });
}

export async function transferBox(data) {
  return haloWorldRequest({
    method: 'post',
    url: '/api/invite/TransferBox',
    headers: {
      Authorization: sessionStorage.getItem('haloWorldToken')
    },
    data: {
      ...data
    }
  });
}

export async function getLiveConfig() {
  return haloWorldRequest({
    method: 'get',
    url: '/api/public/liveConfigV2',
  });
}